import { Button, Typography } from "@mui/material"
import Grid from '@mui/material/Grid';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useState } from "react";
import CreateRoleForm from "../components/create-role-form.component";
import CustomModal from "../../../core/components/ui/custom-modal.component";
import RoleListViewTable from "../components/role-listview-table.component";
const RoleListViewPage = () => {

    const [open, setOpen] = useState(false)
    const [recordChange, setRecordChange] = useState(false)

    // Function to handle modal open/close
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleRecordChange = () => setRecordChange(true);

    return (
        <div>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="body1">Process of defining, assigning, and regulating roles to control user access and permissions effectively.</Typography>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end">
                    <Button  variant="text" startIcon={<AddBoxIcon sx={{ color: '#604CC3' }} />} sx={{ textTransform: 'none' }}  onClick={handleOpen} >
                        Create Role
                    </Button>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <RoleListViewTable recordChange={recordChange}  setRecordChange={setRecordChange} />
                </Grid>
            </Grid>

            <CustomModal  
                open={open}
                handleClose={handleClose}
                title="Create Role"
            >
                <CreateRoleForm handleClose={handleClose} handleRecordChange={handleRecordChange} />
            </CustomModal>

          
        </div>
    )
}


export default RoleListViewPage